
<div class="card-profile" :class="{ page }">
  <spinner v-if="!loaded" />

  <template v-else>
    <card-profile-actions
      :card-id="cardId"
      :card="card"
      :page="page"
      v-on="$listeners"
    />

    <card-profile-details
      :card="card"
      :card-id="cardId"
      :is-admin="isAdmin"
      :is-staff="isStaff"
      :page="page"
      @edit="$emit('edit')"
    />

    <card-profile-collection-investment :card="card" />

    <card-profile-watchlist-details v-if="hasWatchlistData" :card="card" />

    <card-profile-collection-notes :card="card" />

    <card-profile-admin
      v-if="isStaff && cardId"
      :card="card"
      :card-id="cardId"
      :page="page"
    />

    <card-profile-sales-graph
      v-if="showCardProfileSalesGraph"
      :card="card"
      :card-id="cardId"
      :zoom.sync="zoom"
      :scale.sync="scale"
      :page="page"
      @saleClicked="handleGraphSaleClicked"
    />

    <section v-if="profileForList" class="card-profile-pop-section">
      <h4 class="secondary-font">
        Profile
      </h4>

      <div class="card-profile-pop-item" @click="goToProfile">
        <profile-list-item :profile="profileForList" />
      </div>
    </section>

    <card-profile-index :card="card" />

    <card-profile-shop :card="card" :listings="listings" />

    <similar-cards
      v-if="cardId"
      :id="card.id"
      :similar-cards="card.similarCards"
      :page="page"
    />

    <card-profile-information :card="card" />

    <card-profile-set-information :card="card" />

    <card-profile-multipliers :card="card" />

    <card-profile-references :card="card" />
  </template>
</div>
